import React, { useContext } from "react";
import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";

function Header() {
  const location = useLocation();
  const currentPath = location.pathname;

  const { setSignin } = useContext(Context);
  const navigate = useNavigate();

  const yello_links = [
    { path: "/manage-my-points", label: "Manage My Points" },
    { path: "/child-registration", label: "Child Registration" },
    { path: "/change-password", label: "Change Password" },
    { path: "/change-pin", label: "PIN" },
    { path: "/update-profile", label: "Update Profile" },
    { path: "/draw-details", label: "Draw Details" },
    { path: "", label: "Download Patch" },
    { path: "", label: "Play Games" },
    { path: "/change-pin-password", label: "PIN & Password" },
  ];

  const handleLogout = async () => {
    Cookies.remove("fun_ref_admin_security");
    await setSignin(false);
    navigate("/");
  };

  return (
    <>
      <section className="Header">
        <div className="container-fluid p-0">
          <div className="header_container">
            <div className="black_strip"></div>

            <div className="red_strip">
              <ul>
                <li>
                  <a href="">About Us</a>
                </li>{" "}
                |
                <li>
                  <a href="">MGM</a>
                </li>{" "}
                |
                <li>
                  <a href="">Tutorials</a>
                </li>{" "}
                |
                <li>
                  <a href="">FAQ's</a>
                </li>{" "}
                |
                <li>
                  <a href="">Downloads</a>
                </li>{" "}
                |
                <li>
                  <a href="">Contact Us</a>
                </li>
              </ul>
            </div>

            <div className="yellow_strip">
              <ul>
                {yello_links.map((link, index) => (
                  <React.Fragment key={index}>
                    <li>
                      <a
                        href={link.path}
                        className={link.path === currentPath ? "active" : ""}
                      >
                        {link.label}
                      </a>
                    </li>
                    {index < yello_links.length - 1 && " | "}
                    {index === 5 && <br />}
                  </React.Fragment>
                ))}
                |
                <li>
                  <a
                    onClick={() => handleLogout()}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </div>

            <div className="left_img_div">
              <img src="/assets/login/logo.png" className="left_img" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Header;
